<template>
  <div>
    <header-img :list="headerList"></header-img>
    <div class="el-container">
      <div class="main-block">
        <div class="top-title">我的补贴</div>
        <div style="margin: 0 123px;">
          <div class="status-wrap checkErrorBg">
            <div class="left">
              <div class="img-warp checkError">
                <img :src="ErrorImg" />
              </div>
              <div class="status">
                申请状态
                <br />
                <p style="color:#EF5147 ;">未通过</p>
                <span style="font-size: 12px;">不通过原因：{{$route.query.content}}</span>
              </div>
            </div>
          </div>
          <!-- 申请人信息 -->
          <div>
            <div class="h_bg p50">
              <h3>申请人信息</h3>
            </div>
            <el-form :model="detail">
              <el-form-item label="申请人姓名">{{detail.applyRealName}}</el-form-item>
              <el-form-item label="申请人身份证号">{{detail.applyIdCardNumber}}</el-form-item>
              <el-form-item label="申请人联系电话">{{detail.applyPhoneNumber}}</el-form-item>
              <el-form-item label="申请人家庭住址">{{detail.applyAddress}}</el-form-item>
              <el-form-item label="银行账户">{{detail.applyBankAccountNumber}}</el-form-item>
              <el-form-item label="开户银行">{{detail.applyBankName}}</el-form-item>
            </el-form>
          </div>
          <!-- 代替人信息 -->
          <div v-if="detail.proxyRealName">
            <div class="h_bg p50">
              <h3>代替人信息</h3>
            </div>
            <el-form :model="detail">
              <el-form-item label="申请人姓名">{{detail.proxyRealName}}</el-form-item>
              <el-form-item label="申请人身份证号">{{detail.proxyIdCardNumber}}</el-form-item>
              <el-form-item label="申请人联系电话">{{detail.proxyPhoneNumber}}</el-form-item>
              <el-form-item label="申请人家庭住址">{{detail.proxyAddress}}</el-form-item>
              <el-form-item label="与代替人关系">{{detail.proxyRelationApply}}</el-form-item>
            </el-form>
          </div>
          <!-- 补贴信息 -->
          <div>
            <div class="h_bg p50">
              <h3>补贴信息</h3>
            </div>
            <el-table :data="detail.subsidyQualificationsListResults" border>
              <el-table-column
                header-align="center"
                align="center"
                label="补贴项目"
                prop="subsidyProject"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="补贴金额（元）"
                prop="subsidyAmount"
              >
                <template slot-scope="scope">{{scope.row.subsidyAmount / 100}}</template>
              </el-table-column>
            </el-table>
          </div>
          <div class="btn_wrap" style="margin: 40px 0;">
            <el-button class="btns black" @click="$router.go(-1)">返回</el-button>
            <el-button class="btns red" @click="sumbit">重新提交</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderImg from "@/components/HeaderImg";
import ErrorImg from "@/assets/img/check_error.png";
import { sessionStore } from "@/utils/data-management";
export default {
  components: {
    HeaderImg
  },
  data() {
    return {
      headerList: [{ name: "我的补贴", path: "/MySubsidy" }],
      ErrorImg: ErrorImg,
      detail: {}
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$api.apply
        .subsidyProxyDetail({ id: this.$route.query.id })
        .then(res => {
          if (res.code == 1000) {
            this.detail = res.data;
          }
        });
    },
    sumbit() {
      sessionStore.set("subsidyAgain", this.detail);
      this.$goTo("applySubsidy", { num: "2" });
    }
  }
};
</script>
<style lang="scss" scoped>
.el-container {
  width: auto;
  max-width: 1200px;
  margin: 0 auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 16px;
  .el-aside {
    div {
      background: #fff;
      height: 80px;
      line-height: 80px;
      text-align: center;
      color: #3e4860;
    }
    .active {
      background: url("~@/assets/navBarselected.png") no-repeat;
      color: #fff;
    }
  }
}

.main-block {
  width: auto;
  width: 1200px;
  margin: auto 10px;
  background: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 !important;
  .top-title {
    margin: 20px !important;
  }
  .status-wrap {
    height: 110px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &.checkErrorBg {
      background: #fef0f2;
    }
    &.checkingBg {
      background: #fef9f0;
    }
    &.checkSuccessBg {
      background: #f0f9f0;
    }
    .left {
      display: flex;
      align-items: center;
      .status {
        margin-left: 35px;
        p {
          margin: 0;
          font-size: 20px;
          .errorFont {
            font-size: 16px;
            color: #60697e;
            padding-left: 15px;
          }
        }
      }
      .img-warp {
        width: 110px;
        height: 110px;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        &.checking {
          background: #ffaa36;
        }
        &.checkSuccess {
          background: #91a442;
        }
        &.checkError {
          background: linear-gradient(-135deg, #ff7067 0%, #ef5147 100%);
        }
        img {
          width: 40px;
          height: 40px;
          display: block;
        }
      }
    }
  }
  .h_bg {
    margin: 0 0 30px;
  }
}
</style>